/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";

import Filters from "../../../components/Filters";
import TaskTable from "../../../components/Task/TaskTable";
import useForm from "../../../hooks/useForm";
import { cloneDeep, isArray, isEmpty } from "lodash-es";
import { getDay } from "../../../utils/date";
import { getParams } from "../../../utils/params";


const YearEndBoard = (props) => {
  const { ownership } = props


  const [params, setParams] = useState({})

  const {
    form,
    setSubmit,
    handleOnChange,
    // LIST 용
    filterSubmit,
  } = useForm(
    {
      search: {
        title: ''
      },
      range: {
        createdTime: [
          // approvalTargetRequestedTime: [
          getDay(7), getDay()
        ]
      },
      approvalTargetType: 'year_end_draft_request',
    },
  )



  useEffect(() => {
    submit(form);
    setSubmit(submit)
  }, []);

  const submit = (params) => {
    const _params = cloneDeep(params)
    if (isArray(_params.requesterEmployeeIdx))
    {
      _params.requesterEmployeeIdx = _params.requesterEmployeeIdx.map(e => e.idx)
    }
    if (isEmpty(_params.requesterEmployeeIdx))
    {
      _params.requesterEmployeeIdx = undefined
    }
    setParams(getParams(_params))
  }

  const [filters] = useState([
    {
      title: "조회기간",
      type: "CustomDatePicker",
      key: "range.createdTime",
    },
    {
      title: "제목 검색",
      key: "search.title",
      options: {
        placeholder: "검색어 입력",
      },
    },
    {
      title: "요청한 사람",
      type: "searchEmployees",
      defaultValue: [],
      key: "requesterEmployeeIdx",
    },
  ])


  return (
    <>
      <Filters
        filters={filters}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange}
      />
      <TaskTable
        ownership={ownership}
        fixFilter={{ approvalTargetStage: 'all' }}
        params={params}
        isControl={false}
        isOpenToggle={false}
      />

    </>
  );
};

export default YearEndBoard;
